[
  {
    "code" : "T-",
    "description" : "Mixed consign. of T1 and T2 goods"
  },
  {
    "code" : "T1",
    "description" : "External Community Transit"
  },
  {
    "code" : "T2",
    "description" : "Internal Community Transit"
  },
  {
    "code" : "T2F",
    "description" : "Customs Transp. between fisc. areas"
  },
  {
    "code" : "T2SM",
    "description" : "T2 procedure for San Marino"
  },
  {
    "code" : "TIR",
    "description" : "TIR-carnet"
  }
]
